module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_primaerlogo_neg.563aa6f8.svg";